import { defineSearch, param, type RawSearch } from '@/router/search';
export interface ResearchSearch {
  tab?: 'overview' | 'creatives' | 'review' | undefined;
  research_app?: string | undefined;
  competitor?: string | undefined;
  source?: 'google' | 'meta' | 'tiktok' | undefined;
  creative_period?: 'recent' | 'historical' | 'all' | undefined;
  format?: string | undefined;
  country?: string | undefined;
  language?: string | undefined;
  metric?: string | undefined;
  minimum?: number | undefined;
  q?: string | undefined;
  ad?: string | undefined;
  evidence_batch?: string | undefined;
  insight?: string | undefined;
  insight_competitor?: string | undefined;
}
export const parseResearchSearch = (raw: RawSearch): ResearchSearch => ({
  tab: raw.tab === 'insights' ? 'overview' : param.enumValue(raw, 'tab', ['overview', 'creatives', 'review']),
  research_app: param.string(raw, 'research_app'), competitor: param.string(raw, 'competitor'),
  source: param.enumValue(raw, 'source', ['google', 'meta', 'tiktok']),
  creative_period: param.enumValue(raw, 'creative_period', ['recent', 'historical', 'all']),
  format: param.enumValue(raw, 'format', ['image', 'video', 'text', 'carousel', 'mixed', 'unknown']),
  metric: param.string(raw, 'metric'), minimum: param.number(raw, 'minimum', { min: 0 }),
  country: param.string(raw, 'country'), language: param.string(raw, 'language'), q: param.string(raw, 'q'), ad: param.string(raw, 'ad'), evidence_batch: param.string(raw, 'evidence_batch'), insight: param.string(raw, 'insight'), insight_competitor: param.string(raw, 'insight_competitor'),
});
export const researchSearch = defineSearch(parseResearchSearch);
